var render, staticRenderFns
import script from "./SelectTag.vue?vue&type=script&lang=ts&"
export * from "./SelectTag.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTag.vue?vue&type=style&index=0&id=22edf02d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports